"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFieldInput = void 0;
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const input_1 = require("./input");
const LocationField_input_style_1 = require("./LocationField.input.style");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const distance_input_1 = require("./distance.input");
const distance_input_state_1 = require("./distance.input.state");
const LocationField_input_state_1 = require("./LocationField.input.state");
(0, theme_1.addStyles)(LocationField_input_style_1.Style);
exports.LocationFieldInput = {
    view(state) {
        if (state instanceof LocationField_input_state_1.LocationFieldInputState) {
            return ((0, mithril_1.m)('tr', { className: LocationField_input_style_1.CSS.row }, [
                (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.label }, (0, i18n_1.Translate)(state.label)),
                (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.inputs }, [input_1.Input.view(state)]),
                state.hasError() ? (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.MDL.error + ' ' + LocationField_input_style_1.CSS.error }, (0, i18n_1.Translate)(state.error)) : null
            ]));
        }
        else if (state instanceof distance_input_state_1.DistanceInputState) {
            return ((0, mithril_1.m)('tr', { className: LocationField_input_style_1.CSS.row }, [
                (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.label }, (0, i18n_1.Translate)(state.label)),
                (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.inputs }, [distance_input_1.DistanceInput.view(state, services_1.Services.UserSettings.units)]),
                state.hasError() ? (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.MDL.error + ' ' + LocationField_input_style_1.CSS.error }, (0, i18n_1.Translate)(state.error)) : null
            ]));
        }
        return null;
    }
};
//# sourceMappingURL=LocationField.input.js.map